import * as React from "react";
import {translate} from "react-i18next";
import i18n from "i18next";
import {Header} from "../../components/Header";
import TextBody from "../../components/TextBody";
import BottomBar from "../../components/BottomBar";
import TopNav from "../../components/TopNav";
import {Container,Row,Col} from "reactstrap";
import StatusOverview from "../../components/StatusBar";
import vodafoneLogo from "../../media/icons/vf-logo.png";
import {SpacerRow} from "../../components/SpacerRow";
import {BrowserView,MobileView,isMobile} from "react-device-detect";
import InfoBlocks from "../../components/InfoBlocks";
import SingleButton from "../../components/SingleButton";
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import moment from "moment";

class Stage0Welcome extends React.Component {

    constructor(props){
        super(props);
        // console.log( "FNX: Stage0Welcome props");
        // console.log(props);
        this.state = { redButtonDisabled: true, selectedOption: false }
    }

    handleOnChange = (e) =>  {
        console.log('selected option', e.target.value);
        this.setState({ selectedOption: e.target.value});
		// activate Button
		this.state.redButtonDisabled = false;
    }

    /**
     * render
     * @returns {*}
     */
    render() {

        let WelcomeText;
        if(this.props.validationDone){
            WelcomeText = <Header
                textResource={"welcome_name_validation"}
                name={`${this.props.apiData.firstName}`}
            />
        }else{
            WelcomeText = <Header
                textResource={"welcome_techniker_termin_title"}
                name={`${this.props.apiData.firstName} ${this.props.apiData.lastName} `}
            />
        }

        const headerAndWelcomeText = <div>
            {WelcomeText}
            <div style={{marginTop:"20px"}}>
                <p><b>Probier bitte mal aus, ob das Internet an Deinem Router schon funktioniert. Wie das geht, siehst Du <a class="lnk_cc" href="https://www.vodafone.de/hilfe/router-easyboxen-surfsticks.html" target="_blank">hier</a>.</b></p>
                <p><TextBody
                textResource={"welcome_techniker_termin_body2"}
                /></p>
                <p><TextBody
                textResource={"welcome_techniker_termin_body3"}
                /></p>
            </div>
        </div>;

        console.log( "FNX // window.innerWidth = " + window.innerWidth);

        return <Container>
                <MobileView>
                    <Row className={"header"}>
                        <Col xs={2} style={{marginLeft:"-15px"}}>
                            <img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
                        </Col>
                    </Row>
                    <Row style={{paddingTop:"5vh"}}>
                        <Col>
                            {headerAndWelcomeText}
                            <div className={"margin-16"} />
                            <div className={"margin-16"} />
                            <SpacerRow/>
                        </Col>
                    </Row>
                    <Row className={'fixed-to-bottom'} style={{paddingBottom:"50px"}}>

                        <Col xs={{ size: 12 }} className={"twoButtons"}>
                            <div className={window.innerWidth<=359?"button-multiline-mobile":"button-multiline-mobile-NOT"}>
                                <BottomBar
                                    // mainButtonOnClick={this.props.nextStage}
                                    mainButtonOnClick={() => {
                                        this.props.commonSubmitCallback("notWorking")
                                    }}
                                    mainButtonTextResource={"answer_1_2"}
                                />
                                <BottomBar
                                    // mainButtonOnClick={this.props.nextStage}
                                    mainButtonOnClick={() => {
                                        this.state.apiAction = "installed";
                                        this.props.saveUserDataToCCApi( this.state );
                                        this.props.commonSubmitCallback("working")
                                    }}
                                    showBackButtonValidation={true}
                                    backButtonValidationOnClick={true}
                                    backValidationButtonTextResource={"answer_1_1"}
                                />
                            </div>
                        </Col>

                    </Row>
                </MobileView>

                <BrowserView>
					<Row className={"header desktop"}>
						<Col xs={12}>
							<div className={"container"}>
								<Row>
									<Col xs={2} style={{marginLeft:"-15px"}}>
										<img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
									</Col>
								</Row>
							</div>
						</Col>
                    </Row>

                    <Row style={{paddingTop:"20vh"}}>
                        <Col xs={{ size: 10, offset: 1 }}>
                            {headerAndWelcomeText}
                            <div className={"margin-16"} />
                            <div className={"margin-16"} />
                            <SpacerRow/>
                        </Col>
                    </Row>

                    <Row style={{paddingTop:"20px"}}>
                        <Col xl={{ size: 4, offset: 1 }} lg={{ size: 5, offset: 1 }} md={{ size: 6, offset: 1 }} sm={{ size: 12, offset: 0 }} xs={{ size: 12, offset: 0 }} className={"twoButtons"}>
                            <BottomBar
                                // mainButtonOnClick={this.props.nextStage}
                                mainButtonOnClick={() => {
                                    this.props.commonSubmitCallback("notWorking")
                                }}
                                mainButtonTextResource={"answer_1_2"}
                            />
                        </Col>
                        <Col xl={{ size: 4, offset: 0 }} lg={{ size: 5, offset: 0 }} md={{ size: 6, offset: 0 }} sm={{ size: 12, offset: 0 }} xs={{ size: 12, offset: 0 }} className={"twoButtons"}>
                            <BottomBar
                                // mainButtonOnClick={this.props.nextStage}
                                mainButtonOnClick={() => {
                                    this.state.apiAction = "installed";
                                    this.props.saveUserDataToCCApi( this.state );
                                    this.props.commonSubmitCallback("working")
                                }}
                                showBackButtonValidation={true}
                                backButtonValidationOnClick={true}
                                backValidationButtonTextResource={"answer_1_1"}
                            />
                        </Col>
                    </Row>

                </BrowserView>
            </Container>;
    }
}

export default translate("translations")(Stage0Welcome);